import { useLocation } from "react-router-dom";
import { AppHeader } from "@/components/AppHeader";
import type { TeamMember } from "@/components/TeamAvatars";

interface ProjectHeaderProps {
  syncStatus?: React.ReactNode;
  title?: React.ReactNode;
  showBack?: boolean;
  backTo?: string;
  beforeNavigate?: () => Promise<boolean>;
  teamMembers?: TeamMember[];
  onToggleTeam?: () => void;
  onMembersChange?: (members: TeamMember[]) => void;
  canManageTeam?: boolean;
}

function getProjectIdFromLocation(location: ReturnType<typeof useLocation>): string | null {
  const projectIdFromQuery = new URLSearchParams(location.search).get("projectId");
  const projectIdFromPath = /^\/project\/([^/]+)(?:\/|$)/.exec(location.pathname)?.[1] ?? null;
  return projectIdFromQuery ?? projectIdFromPath;
}

export function ProjectHeader({ syncStatus, title, showBack = true, backTo, beforeNavigate, teamMembers, onToggleTeam, onMembersChange, canManageTeam }: ProjectHeaderProps) {
  const location = useLocation();
  const projectId = getProjectIdFromLocation(location);
  const computedBackTo = backTo ?? (projectId ? `/project/${projectId}` : "/");

  return (
    <AppHeader
      showBack={showBack}
      backTo={computedBackTo}
      beforeNavigate={beforeNavigate}
      syncStatus={syncStatus}
      title={title}
      teamMembers={teamMembers}
      onToggleTeam={onToggleTeam}
      onMembersChange={onMembersChange}
      canManageTeam={canManageTeam}
    />
  );
}
